<mat-card>
    <mat-card-content class="title">
        <div class="container-title-tooltip">
            <p class="title-market-trend">{{title}}</p>
            <mat-icon matTooltipClass="tooltip-info" matTooltip="{{tooltipInfo}}" #tooltip="matTooltip" (click)="tooltip.toggle()">info</mat-icon>
        </div>
    </mat-card-content >
    <mat-card-content class="container-content">
        <ng-content></ng-content>
    </mat-card-content>
</mat-card>
